import { Content, Layout } from "@portal/BaseComponents/Layout/AntLayout";
import { PageHeader } from "@portal/Components/Layout/Header/Header";
import { InitialPage } from "@portal/pages/InitialPage/InitialPage";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { authAtom } from "../../../../store/auth/auth";
import { PageOutLet } from "../../Components/routerComponent";
import { AppPageParams } from "../../constants/page-info";
import { usePageNavigate } from "../../hooks/usePageNavigae";

function Protected() {
  const { authStatus } = useAtomValue(authAtom);
  const { customer_id } = useParams<AppPageParams>();
  const navigate = usePageNavigate();
  const location = useLocation();

  function handleAuthRoute() {
    if (authStatus !== "not-authenticated") return;
    if (location.pathname !== "/" || location.search) {
      const searchParams = new URLSearchParams(location.search);
      if (customer_id && searchParams.has("entity_type")) {
        searchParams.append("customer_id", customer_id);
      }
      navigate({
        appPage: "LOGIN",
        searchParams,
      });
      return;
    }
    navigate({ appPage: "LOGIN" });
  }
  useEffect(handleAuthRoute, [authStatus, navigate, location, customer_id]);

  if (authStatus !== "authenticated") {
    return <InitialPage />;
  }

  return (
    <Layout style={{ height: "100%" }}>
      <PageHeader />
      <Content height="page">
        <PageOutLet />
      </Content>
    </Layout>
  );
}

export { Protected };
